import { Button } from "@controls";
import { useTranslation } from "react-i18next";

import Modal from "../modal";

interface ConfirmationModalProps {
  title: string;
  message: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmationModal({
  title,
  message,
  open,
  onOpenChange,
  onConfirm,
  onCancel,
}: ConfirmationModalProps) {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      title={title}
      description={message}
    >
      <div className="flex gap-2 justify-end">
        <div className="min-w-24">
          <Button type="button" variant="outline" onClick={onCancel}>
            {t("cancel")}
          </Button>
        </div>
        <div className="min-w-24">
          <Button type="button" onClick={onConfirm}>
            {t("confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
